import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    coaches: [],
    stats: null,
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
    },
};

const coachSlice = createSlice({
    name: 'coach',
    initialState,
    reducers: {
        setCoaches: (state, action) => {
            state.coaches = action.payload;
        },
        setStats: (state, action) => {
            state.stats = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const { setCoaches, setStats, setPagination, setLoading, setError, clearError } =
    coachSlice.actions;

export default coachSlice.reducer;
